
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/content_wall/templates/moment_empty_search_results"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='posts_container'><div class='end_of_content_title' aria-live=\"polite\">No results found for &ldquo;<b class=\"heavy\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"search_term") || (depth0 != null ? lookupProperty(depth0,"search_term") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"search_term","hash":{},"data":data,"loc":{"start":{"line":1,"column":127},"end":{"line":1,"column":142}}}) : helper)))
    + "</b>&rdquo;</div></div>\n";
},"useData":true});
    }).call(this);
  